function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { get, getRawValue } from '../utils/get';
import { CONTEXT_PROPS } from '../types/ContextProps';

var _getKeys = function getKeys(IDs, userVisible) {
  var keysMetaData = Object.values(IDs).reduce(function (acc, val) {
    var _objectSpread2;

    return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread2 = {}, _objectSpread2[val] = {
      userVisibility: userVisible.includes(val)
    }, _objectSpread2));
  }, {});
  return Object.values(IDs).map(function (key) {
    return _objectSpread({
      key: key
    }, keysMetaData[key]);
  });
};

export { _getKeys as getKeys };
var siteDataKeys = {
  SITE_NAME: 'site.name',
  SITE_URL: 'site.url',
  INDEX_SITE: 'site.index',
  ROBOTS_FROM_USER_PATTERN: 'userPatterns.robots',
  SITE_IMAGE: 'site.image',
  SITE_IMAGE_WIDTH: 'site.imageWidth',
  SITE_IMAGE_HEIGHT: 'site.imageHeight',
  FB_ADMINS: 'site.facebookAdminId',
  NEXT: 'site.nextLink',
  PREV: 'site.prevLink',
  BUSINESS_NAME: 'site.business.name',
  BUSINESS_LOCATION_COUNTRY: 'site.business.location.country',
  BUSINESS_LOCATION_STATE: 'site.business.location.state',
  BUSINESS_LOCATION_CITY: 'site.business.location.city',
  BUSINESS_LOCATION_STREET: 'site.business.location.street',
  BUSINESS_LOCATION_DESCRIPTION: 'site.business.location.description',
  BUSINESS_DESCRIPTION: 'site.business.description',
  BUSINESS_LOGO: 'site.business.logo',
  BUSINESS_LOCALE: 'site.business.locale'
};
var userVisibleSiteKeys = [siteDataKeys.SITE_NAME, siteDataKeys.BUSINESS_NAME, siteDataKeys.BUSINESS_LOCATION_COUNTRY, siteDataKeys.BUSINESS_LOCATION_STATE, siteDataKeys.BUSINESS_LOCATION_CITY, siteDataKeys.BUSINESS_LOCATION_STREET, siteDataKeys.BUSINESS_LOCATION_DESCRIPTION, siteDataKeys.BUSINESS_DESCRIPTION, siteDataKeys.BUSINESS_LOGO];

var getSiteData = function getSiteData(item) {
  var _ref;

  return _ref = {}, _ref[siteDataKeys.SITE_NAME] = get(item, "context." + CONTEXT_PROPS.SITE_NAME), _ref[siteDataKeys.SITE_URL] = get(item, "context." + CONTEXT_PROPS.SITE_URL), _ref[siteDataKeys.INDEX_SITE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_SITE), _ref[siteDataKeys.ROBOTS_FROM_USER_PATTERN] = getRawValue(item, "context." + CONTEXT_PROPS.ROBOTS_FROM_USER_PATTERN), _ref[siteDataKeys.SITE_IMAGE] = get(item, "context." + CONTEXT_PROPS.SITE_OG_IMAGE), _ref[siteDataKeys.SITE_IMAGE_WIDTH] = get(item, "context." + CONTEXT_PROPS.OG_IMAGE_WIDTH), _ref[siteDataKeys.SITE_IMAGE_HEIGHT] = get(item, "context." + CONTEXT_PROPS.OG_IMAGE_HEIGHT), _ref[siteDataKeys.FB_ADMINS] = get(item, "context." + CONTEXT_PROPS.FB_ADMINS), _ref[siteDataKeys.NEXT] = get(item, "context." + CONTEXT_PROPS.NEXT), _ref[siteDataKeys.PREV] = get(item, "context." + CONTEXT_PROPS.PREV), _ref[siteDataKeys.BUSINESS_NAME] = get(item, "context." + CONTEXT_PROPS.BUSINESS_NAME), _ref[siteDataKeys.BUSINESS_LOCATION_COUNTRY] = get(item, "context." + CONTEXT_PROPS.BUSINESS_LOCATION_COUNTRY), _ref[siteDataKeys.BUSINESS_LOCATION_STATE] = get(item, "context." + CONTEXT_PROPS.BUSINESS_LOCATION_STATE), _ref[siteDataKeys.BUSINESS_LOCATION_CITY] = get(item, "context." + CONTEXT_PROPS.BUSINESS_LOCATION_CITY), _ref[siteDataKeys.BUSINESS_LOCATION_STREET] = get(item, "context." + CONTEXT_PROPS.BUSINESS_LOCATION_STREET), _ref[siteDataKeys.BUSINESS_LOCATION_DESCRIPTION] = get(item, "context." + CONTEXT_PROPS.BUSINESS_LOCATION_DESCRIPTION), _ref[siteDataKeys.BUSINESS_DESCRIPTION] = get(item, "context." + CONTEXT_PROPS.BUSINESS_DESCRIPTION), _ref[siteDataKeys.BUSINESS_LOGO] = get(item, "context." + CONTEXT_PROPS.BUSINESS_LOGO), _ref[siteDataKeys.BUSINESS_LOCALE] = get(item, "context." + CONTEXT_PROPS.BUSINESS_LOCALE), _ref;
};

export function enrichWithSiteLevelData(adapter) {
  var IDs = _objectSpread(_objectSpread({}, siteDataKeys), adapter.IDs);

  return _objectSpread(_objectSpread({}, adapter), {}, {
    IDs: IDs,
    getData: function getData(item) {
      return _objectSpread(_objectSpread({}, getSiteData(item)), adapter.getData(item));
    },
    getKeys: function getKeys(_temp) {
      var _ref2 = _temp === void 0 ? {} : _temp,
          _ref2$exposeBusinessK = _ref2.exposeBusinessKeys,
          exposeBusinessKeys = _ref2$exposeBusinessK === void 0 ? false : _ref2$exposeBusinessK;

      return [].concat(exposeBusinessKeys ? _getKeys(siteDataKeys, userVisibleSiteKeys) : [], adapter.getKeys());
    }
  });
}